import React from 'react';
import type { DraggableProvidedDragHandleProps } from '@hello-pangea/dnd';
import CheckoutReview from '../checkout-components/CheckoutReview';
import { useBuilderStore } from '../../../store/checkoutBuilder/BuilderContext';

interface ReviewAdapterProps {
  componentId: string;
  selected: boolean;
  dragHandleProps?: DraggableProvidedDragHandleProps | null;
}

const ReviewAdapter: React.FC<ReviewAdapterProps> = ({ componentId, selected, dragHandleProps }) => {
  const { state, selectNode, deleteNode, duplicateNode } = useBuilderStore();
  const component = state.document.nodes[componentId];

  if (!component || component.type !== 'component') {
    return null;
  }

  return (
    <CheckoutReview
      selected={selected}
      config={component.props || {}}
      onSelect={() => selectNode(componentId)}
      onDelete={() => {
        if (window.confirm('Tem certeza que deseja excluir esta avaliação?')) {
          deleteNode(componentId);
        }
      }}
      onDuplicate={() => duplicateNode(componentId)}
      dragHandleProps={dragHandleProps}
    />
  );
};

export default ReviewAdapter;
